import {
    PAGE_SETTED,
    PAGE_HOME
} from "../consts/consts";

const initialState = {
    page: PAGE_HOME
};

const setPage = (page_type) => {
    return {
        page: page_type
    }
};

const updatePage = (state, action) => {

    if (state === undefined) {
        return initialState;
    }

    switch (action.type) {
        case PAGE_SETTED:
            return setPage(action.payload);
        default:
            return state.page;
    }

};

export {
    updatePage
}